import React, { useState } from 'react';
import * as S from './styles';
import { Icon } from '@iconify/react'; // Import the Edit icon

interface CarteiraCurrencyInputProps {
  // eslint-disable-next-line no-unused-vars
  onValueChange: (value: string) => void;
  editIcon?: boolean;
}

export function CarteiraCurrencyInput ({ onValueChange, editIcon }: CarteiraCurrencyInputProps) {
  const [valueInCents, setValueInCents] = useState(0);

  function handleChange (e: React.ChangeEvent<HTMLInputElement>) {
    // Remove todos os caracteres que não sejam dígitos
    const inputValue = e.target.value.replace(/\D/g, "");
    
    // Verifica se o valor é válido (apenas números)
    if (inputValue === "" || /^\d+$/.test(inputValue)) {
      const newValueInCents = Math.min(Number(inputValue || 0), 1_000_000_000_000); 
      setValueInCents(newValueInCents);

      const newValueForAPI = (newValueInCents / 100).toFixed(2);
      onValueChange(newValueForAPI);
    }
  }

  function handleKeyDown (e: React.KeyboardEvent<HTMLInputElement>) {
    // Permite: backspace, delete, tab, escape, enter, home, end, setas
    const allowedKeys = [
      'Backspace', 'Delete', 'Tab', 'Escape', 'Enter', 
      'Home', 'End', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'
    ];
    
    // Permite Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X, Ctrl+Z
    if (e.ctrlKey && ['a', 'c', 'v', 'x', 'z'].includes(e.key.toLowerCase())) {
      return;
    }
    
    // Se não é uma tecla permitida e não é um número, previne a entrada
    if (!allowedKeys.includes(e.key) && !/^[0-9]$/.test(e.key)) {
      e.preventDefault();
    }
  }

  function handlePaste (e: React.ClipboardEvent<HTMLInputElement>) {
    e.preventDefault();
    const pastedText = e.clipboardData.getData('text');
    
    // Remove todos os caracteres que não sejam dígitos do texto colado
    const numericValue = pastedText.replace(/\D/g, "");
    
    if (numericValue && /^\d+$/.test(numericValue)) {
      const newValueInCents = Math.min(Number(numericValue), 1_000_000_000_000);
      setValueInCents(newValueInCents);
      
      const newValueForAPI = (newValueInCents / 100).toFixed(2);
      onValueChange(newValueForAPI);
    }
  }

  function formatToBRL (value: number) {
    const valueFormated = new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(value / 100);

    return valueFormated;
  }

  return (
    <S.Container>
      <S.Title>Digite o Valor do Depósito</S.Title>
      <S.InputWrapper>
        <S.DepositoCurrencyInput
          type="text"
          value={"     " + formatToBRL(valueInCents)}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          onPaste={handlePaste}
          placeholder="R$0,00"
          autoFocus
        />
        {editIcon && (
          <S.IconWrapper>
            <Icon 
              icon="mdi:pencil" 
              color="#555" 
              width={18} 
              height={18} 
              style={{ 
                cursor: 'pointer',
                transition: 'color 0.2s ease',
              }} 
            />
          </S.IconWrapper>
        )}
      </S.InputWrapper>
      {valueInCents == 0 ? <span style={{ color: 'red', fontSize: '14px', marginTop: '4px' }}>Insira um valor</span> : <></>}
    </S.Container>
  )
}
